/* eslint-disable */
import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableFooter,
} from '@material-ui/core';
import { CurrencyFormatter } from '../Utils/CurrencyFormatter';
const WidgetBalance = ({ data }) => {

  return (
    <TableContainer component={Paper} style={{marginTop: "auto"}}>
    <Table>
      <TableBody>
        {data.map((item, index) => (
          <TableRow key={index} style={index === data.length - 1 ? { backgroundColor: 'rgb(231, 232, 232)', color: 'white' } : {}}>
            <TableCell style={{ color: index === data.length - 1 ? 'rgb(66, 82, 110)' : 'black', padding: '10px 16px'}}>{item.name}</TableCell>
              <TableCell style={{ color: index === data.length - 1 ? 'rgb(66, 82, 110)' : '#024787', fontWeight: 'bold', padding: '10px 16px', textAlign: 'right'}}><CurrencyFormatter value={item.value}/></TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
  );
};

export default WidgetBalance;
